<template>
  <v-dialog v-bind="$attrs" v-on="$listeners" :max-width="480">
    <v-card class="customer-balance-dialog">
      <v-card-title>增减用户余额</v-card-title>
      <v-container fluid class="px-6">
        <v-text-field label="变更标题" hint="例如：赠送、补偿" class="required" v-model="form.title" />
        <v-select label="变更类型" :items="changeTypeList" v-model="form.change_type" class="required" />
        <v-select label="权益" :items="equityList" v-model="form.equity_id" class="required" />
        <InputEquityAmount :label="equityLabel" :pattern="equityPattern" v-model="form.amount" class="required" />
        <v-row class="mt-8">
          <v-col cols="8">
            <v-btn width="100%" color="primary" @click="onExecute" :loading="isExecuteLoading"
              :disabled="!canExecute">执行</v-btn>
          </v-col>
          <v-col cols="4">
            <v-btn width="100%" outlined color="secondary" @click="onCancel">取消</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import { BalanceChangeType } from '@/plugins/balance'
import InputEquityAmount from '@/components/InputEquityAmount.vue'
import { equityStore } from '@/store/equity'
import { EquityPattern } from '@/plugins/payment'
import { balanceTaskStore } from '@/store/balanceTask'

const changeTypeList = [
  {
    text: '增加余额',
    value: BalanceChangeType.TASK_INCREASE,
  },
  {
    text: '减少余额',
    value: BalanceChangeType.TASK_DECREASE,
  },
]

export default {
  name: 'CustomerDetailPage',
  components: { InputEquityAmount },
  props: {
    customerId: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      changeTypeList,
      form: {
        title: '',
        change_type: BalanceChangeType.TASK_INCREASE,
        equity_id: null,
        amount: null,
      },
      isExecuteLoading: false,
    }
  },
  computed: {
    equityList() {
      return equityStore.list.map(item => {
        return {
          text: item.name,
          value: item.id,
        }
      })
    },
    equity() {
      if (!this.form.equity_id) {
        return null
      }
      return equityStore.get(this.form.equity_id)
    },
    equityLabel() {
      return {
        [EquityPattern.SUBSCRIPTION]: '时长',
        [EquityPattern.PROMOTER]: '时长',
        [EquityPattern.CONSUMABLE]: '数量',
      }[this.equityPattern]
    },
    equityPattern() {
      return this.equity?.pattern ?? EquityPattern.SUBSCRIPTION
    },
    canExecute() {
      return this.form.equity_id && this.form.title && this.form.amount
    },
  },
  methods: {
    async onExecute() {
      if (!this.canExecute || this.isExecuteLoading) {
        return
      }
      const payload = {
        ...this.form,
        customer_id: this.customerId,
        should_execute: true,
      }
      let result
      this.isExecuteLoading = true
      try {
        result = await balanceTaskStore.doCreateOneshot(payload)
      } catch (ex) {
        this.$toasted.error(ex.message)
        return
      } finally {
        this.isExecuteLoading = false
      }
      this.$toasted.success('执行成功')
      this.$emit('input', false)
      this.$emit('success', result)
    },
    onCancel() {
      this.$emit('input', false)
    },
  },
}
</script>

<style lang="less" scoped></style>
